import React from 'react';
import { BsExclamationTriangle } from "react-icons/bs";
import "./styles.css";

export type ProgressbarProps = {
	size: number;
	alertSize: number;
	maxSize: number;
	isLoader: boolean;
	alertMessage: string;
};

export function Progressbar({ size, alertSize, maxSize, isLoader, alertMessage }: ProgressbarProps) {
  return size ?
    <>
        {isLoader ? (
          <p className="progressbar-title">{alertMessage}</p>
        ) : size > maxSize ? (
          <p className="progressbar-title progressbar-red">
            <BsExclamationTriangle className="mr-2" /> {alertMessage}
          </p>
        ) : null}
        <div className="progressbar-container">
          <div
            className={
              isLoader ?
                "progressbar-animated"
              :
                alertSize && size > alertSize ?
                  "progressbar-animated-red"
                : "progressbar-animated"
            }
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            style={{ width: `${size > maxSize ? 100 : (size * 100) / maxSize}%` }}>
            {isLoader ? null : <p className="progressbar-text">{Math.round((size * 100) / maxSize)}%</p>}
          </div>
        </div>
      </>
		: null
}
Progressbar.defaultProps = {
  size: 50,
  alertSize: 70,
  maxSize: 100,
  isLoader: false,
  alertMessage: 'test'
}